module.exports = __webpack_public_path__ + "img/7.8fa3557a.png";